import styled, { css } from 'styled-components';
export const BasicMenuCss = css(["", " top:", ";right:", ";left:", ";transform:", ";> span{", "}> li{", " cursor:", ";&.selected{", "}&:hover{background:getHoveredElementBackground('white');}}"], {
  "position": "absolute",
  "zIndex": "100",
  "width": "fit-content",
  "borderRadius": "0.75rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem"
}, props => props.customStyles?.top ? props.customStyles?.top : '50%', props => props.customStyles?.right ? props.customStyles?.right : '0', props => props.customStyles?.left ? props.customStyles?.left : '', props => props.customStyles?.transform ? props.customStyles?.transform : '', {
  "paddingBottom": "0.5rem",
  "paddingLeft": "1rem",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(105 117 134 / var(--tw-text-opacity, 1))"
}, {
  "height": "2.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.62rem",
  "paddingBottom": "0.62rem",
  "textAlign": "start",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500"
}, props => props.isLoading ? 'wait' : 'pointer', {
  "--tw-text-opacity": "1",
  "color": "rgb(34 106 250 / var(--tw-text-opacity, 1))"
});
export const BasicMenu = styled.ul.withConfig({
  componentId: "sc-1uonepi-0"
})(["", ""], BasicMenuCss);
export const BasicMenuItemContent = styled.div.withConfig({
  componentId: "sc-1uonepi-1"
})(["&{", " > div{", "}}"], {
  "display": "flex",
  "width": "10rem",
  "alignItems": "center",
  "justifyContent": "space-between"
}, {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500"
});
export const SelectStudentDropdownCustomControl = styled.div.withConfig({
  componentId: "sc-1uonepi-2"
})(["&{", " div[class*='ValueContainer']{input{width:fit-content !important;}}}"], {
  "position": "relative",
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem",
  "padding": "0.5rem"
});